export default {
  id: 95,
  title: 'Target #95 - Pokeball',
  url: 'https://cssbattle.dev/play/95',
  colors: ['#6CB3A9', '#D25B70', '#FFFFFF', '#781728', '#F6DF96'],
  solution:
    '<a a><a b><a c><style>[b],[c]{border-radius:9in}body{background:#6cb3a9}a{position:fixed}[a]{background:#781728;top:140;left:110;width:180;height:20}[b]{top:50;left:100;width:200;height:200;background:linear-gradient(to bottom,#d25b70,#d25b70 90px,transparent 90px,transparent 110px,#fff 110px)}[c]{top:115;left:165;width:50;height:50;background:#f6df96;border:10px solid #781728}</style>',
}
